<div class="row">
  <div class="col"></div>
  <div class="col-auto" style="position: relative;">
    <i class="fas fa-sync-alt fa-lg update-icon" (click)="file.click()" style="position: absolute; cursor: pointer;"></i>
    <img *ngIf="user && !user.picture_b64" [src]="'assets/img/10.jpg'" alt="User picture">
    <img *ngIf="user && user.picture_b64" [src]="user.picture_b64" alt="User picture">
    <input type="file" (change)="detectFiles($event)"
           class="form-control" accept="image/*" hidden #file>
  </div>
  <div class="col"></div>
</div>
